export const NO_IMAGE_SRC = "/assets/img/icons/no-content/no-image.svg";